<template>
  <div id="toolbar" class="toolbar">
    <div class="roomBar" :class="'typebg' + styleType">
      <!-- <van-button
        type="info"
        v-if="tid"
        @click="showQuickMsgPanelAction"
        style="margin-left: 10px;padding:0 5px;"
        size="small"
        >快速评论</van-button> -->
      <img
        v-if="picComment"
        @click="picCommentTap"
        style="width: 20px;display: inline-block;margin-left: 10px;"
        src="../../../statics/imgs/home/pic.png"
      />
      <img
        v-if="isshowgift && Sendflowers == 'true'"
        @click="sendFllowerTap(1)"
        style="width: 20px;display: inline-block;margin-left: 10px;"
        src="../../../statics/imgs/home/fllower.png"
      />
      <img
        v-if="isshowgift  && Sendflowers == 'true'"
        @click="sendFllowerTap(2)"
        style="width: 20px;display: inline-block;margin-left: 10px;"
        src="../../../statics/imgs/home/zan.png"
      />
      <div v-if="is_all_users_muted" style="width:100%;background-color: #FFFFFF;padding-bottom: 5px;padding-top: 5px;padding-left: 5px;margin-left: 10px;margin-right: 10px;border: solid 1px #F5F5F5; border-radius: 10px;">
         全员禁言中...
      </div>
      <van-field
        v-else
        style="background-color: #FFFFFF;padding-bottom: 5px;padding-top: 5px;padding-left: 5px;margin-left: 10px;margin-right: 10px;border: solid 1px #F5F5F5; border-radius: 10px;"
        v-model="inputValue"
        @keyup.enter="sendMsg"
        placeholder="说点什么..."
      />
      <van-button
        :disabled="is_all_users_muted"
        type="primary"
        @touchstart="sendMsg"
        class="senMsgBtn"
        size="small"
        >发送</van-button
      >
    </div>

    <van-popup
      v-model="imgStatus"
      :close-on-click-overlay="false"
      :lock-scroll="false"
      :lazy-render="false"
    >
      <div class="occupy imgPl">
        <div class="addimg">
          <p v-show="!occupyImg">添加图片</p>
          <div id="container" class="container">
            <div @click="$refs.onkeyupdateBtn.click()"  class="selectfiles">
              <div class="img" v-if="occupyImg"><img :src="occupyImg" /></div>
            </div>
          </div>
        </div>
        <div class="textarea">
          <textarea
            cols="30"
            rows="3"
            maxlength="60"
            placeholder="再说点什么…"
            v-model="occupyText"
          ></textarea>
          <div class="number">
            <span>{{ occupyText.length }}</span
            >/60
          </div>
        </div>
        <div class="btns">
          <a class="cancel" @click="occupyRefresh">取消</a>
          <a class="button" @click="imgPl" v-if="uploadAble">确定</a>
          <a class="button disabled" v-else>确定</a>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="occupyStatus"
      :close-on-click-overlay="false"
      :lazy-render="false"
      class="iosPosition"
    >
      <div class="occupy">
        <div class="title">重金霸屏</div>
        <p>霸评内容：</p>
        <div class="textarea">
          <textarea
            cols="30"
            rows="3"
            maxlength="60"
            placeholder="请勿发布广告涉黄等内容，霸屏不支持退款"
            v-model="occupyText"
          ></textarea>
          <div class="number">
            <span>{{ occupyText.length }}</span
            >/60
          </div>
        </div>

        <div class="addimg">
          <div id="container" class="container">
            <div id="selectfiles1" class="selectfiles">
              <div class="img" v-if="occupyImg"><img :src="occupyImg" /></div>
              <img class="guide" v-else :src="imgPath + 'home/img.png'" />
            </div>
          </div>
        </div>

        <p>霸屏时间：</p>
        <div class="times">
          <a
            v-for="(item, index) in occupyList"
            @click="choice(index)"
            :class="{ cur: occupyList[payLevel] == item }"
            :key="index"
            >{{ item }}S</a
          >
        </div>
        <p class="money">
          预计支付金额：<span
            >￥{{ ((1 + payLevel) * 100 * payPrice) / 100 }}</span
          >
        </p>
        <div class="btns">
          <a class="cancel" @click="occupyRefresh">取消</a>
          <a class="button" @click="occupy" v-if="uploadAble">确定</a>
          <a class="button disabled" v-else>确定</a>
        </div>
        <p class="prompt">
          温馨提示：请在主办方提供的大屏幕查看您的霸屏内容与效果。
        </p>
      </div>
    </van-popup>

  <!-- 礼物列表
	<van-popup v-model="showgift" position="bottom" class="full bottomView">
		<giftAlertView :renum="showgift" :giftList="giftList" :fans_id="fans_id"></giftAlertView>
	</van-popup> -->
	<!-- 评论弹窗 -->
    <van-popup v-model="commentBox">
      <textarea
        style="padding: 10px;"
        v-focus="focusState"
        @click.stop=""
        @focus="inputFocus"
        @blur="inputblur"
        @keyup.enter="sendMsg"
        class="textarea"
        v-model="inputValue"
        :placeholder="placeholder"
        cols="30"
        rows="3"
      ></textarea>
      <div class="btnBox">
        <a
          class="btn"
          style="width: 100%;"
          @click="sendMsg"
          :class="'type' + styleType"
          >发送</a
        >
      </div>
    </van-popup>

    <!--快速评论-->
    <van-popup
      v-model="isShowQuickPanel"
      position="bottom"
      style="overflow:visible;width:90%;"
    >
      <div class="quickArrow"></div>
      <ul class="quickPanel">
        <li
          v-for="(word, index) in commentList"
          @click="sendquickMsgAction(index)"
          :key="index"
        >
          <span>{{ word.comment }}</span>
        </li>
      </ul>
    </van-popup>

    <!--礼物打赏-->
    <div class="getGift" v-show="showgetGift">
      <img
        :src="giftMessages.gift_pic_url"
        :alt="giftMessages.gift_name"
        class="giftImg"
      />
      <span>{{ giftMessages.nick }} 赠送</span>
      <span class="name">{{ giftMessages.gift_name }}</span>
      <span class="num">x {{ giftMessages.gift_num }}</span>
    </div>
    <input ref="onkeyupdateBtn" @click="(e) => {e.target.value = ''}" @change="getFilef($event)" type="file" v-show="false" />
  </div>
</template>

<script>
import Vue from "vue";
import handleIm from "../../kits/im/handleim.js";
import tool from "../../kits/Tools.js";
import Bus from "../../kits/eventBus.js";
import { Toast, Popup } from "vant";
Vue.use(Popup).use(Toast);
import qs from "qs";
import giftAlertView from "./giftAlertView.vue";
import { mapGetters } from "vuex";
import { cosUploadFile } from "../../kits/cosUpload.js";

export default {
  data() {
    return {
      tid: 0,
      ds_id: "",
      imgPath: "",
      fid: "",
      isReply: false, //是否是回复
      comment_id: 0,
      isShowQuickBtn: false,
      inputValue: "",
      placeholder: "请输入你要发表的内容",
      focusState: false,
      imgStatus: false,
      occupyStatus: false,
      occupyText: "",
      occupyImg: "",
      occupyImgUrl: "",
      occupyFile: "",
      occupyPath: "",
      occupyList: [5, 10, 15],
      payLevel: 1,
      occupyImgUp: false,
      occupyRatio: 1,
      showgift: false,
      commentBox: false,
      isShowQuickPanel: false,
      key: "uploads/comment/",
      expire: 0,
      g_object_name: "live",
      suffix: "",
      g_object_name_type: "local_name",
      now: Date.parse(new Date()) / 1000,
      timestamp: Date.parse(new Date()) / 1000,
      uploadAble: false,
      giftTimer: null,
      showgetGift: false,
      giftMessages: {},
      sendMsgTimer: null,
      sendFollowerText:"",
      // flowers: ''
    };
  },
  directives: {
    focus: {
      update: function(el, { value }) {
        if (value) {
          el.focus();
        }
      },
    },
  },
  props: [
    "styleType",
    "picComment",
    "isshowgift",
    "isWeixin",
    "commentList",
    "isIOS",
    "fans_id",
    "isMaster",
    "giftList",
    "wallSign",
    "wall_id",
    "payPrice",
    "verify_comment",
    "directStatus",
    "is_all_users_muted",
    "say_self"
  ],
  components: {
    giftAlertView,
  },
  computed: {
    ...mapGetters({
      userConfig: "dsInfo/getUserConfig",
      BusinessConfigs:"dsInfo/getBusinessConfigs",
      Sendflowers: 'dsInfo/getSendflowers'
    }),
  },
  mounted() {
    var that = this;
    this.tid = tool.getQueryString("tid");
    this.imgPath = tool.imgPath();
    Bus.$on("showcomment", function() {
      that.showcommentBox();
    });
    Bus.$on("replying", function(msg) {
      that.reply(msg);
    });
  },
  methods: {
    async getFilef(e){
      const file = e.target.files[0]
      try {
        this.occupyImg =  await cosUploadFile(file,this.uid)
      } catch (error) {
      }
      this.uploadAble = true;
    },
    picCommentTap(){
      if (this.is_all_users_muted) {
          Toast("当前直播全员禁止发言");
          return
      }
       this.imgStatus = true
    },
    sendFllowerTap(type) {
      if (type == 1) {
        this.sendFollowerText =
          "送给老师的鲜花<img style='width:20px;ertical-align: bottom;' src='https://tengfaceliveuser.tengface.net/web/wx-user/flower/xianhua.png'/>";
      } else if (type == 2) {
        this.sendFollowerText =
          "给老师点个赞<img style='width:20px;vertical-align: bottom;' src='https://tengfaceliveuser.tengface.net/web/wx-user/flower/dianzhan.png'/>";
      }

      this.sendMsg(1);
    },
    onInputClicked() {
      this.commentBox = true;
    },
    imgPlShow() {
      this.imgStatus = !this.imgStatus;
    },
    showcommentBox() {
      this.focusState = !this.focusState;
      this.commentBox = !this.commentBox;
    },
    giftClicked() {
      this.showgift = true;
    },
    showQuickMsgPanelAction() {
      this.isShowQuickPanel = true;
      this.commentBox = false;
    },
    //获取焦点
    inputFocus() {
      this.focusState = true;
      if (!this.isIOS) {
        this.isShowQuickBtn = true;
      }
    },
    inputblur() {
      window.scrollTo(0, 0);
      var that = this;
      document.body.addEventListener("click", function() {
        that.placeholder = "请输入你要发表的内容";
        that.isReply = false;
        that.comment_id = "";
      });
      this.isShowQuickBtn = false;
      this.focusState = false;
    },
    sendMsg(type) {
      let contentText = ""
      if (type == 1) {
        contentText =  this.sendFollowerText 
      } else {
        contentText = this.inputValue.replaceAll("<","#").replaceAll(">","#").replaceAll("&lt;","#").replaceAll("&gt;","#")
      }

      if (
        this.directStatus == "end" &&
        this.userConfig && this.userConfig.all_no_speak
      ) {
        Toast("当前未直播禁止发言");
        return;
      }

      if (this.is_all_users_muted) {
          return
      }

      if (contentText.length < 1) {
        Toast("发送消息不能为空");
        return false;
      }

      // if (this.inputValue.length > 500) {
      //   Toast("发送消息不能超过500字");
      //   return false;
      // }
       if (contentText == "@debug") {
         this.testSendMessage(location.href,'')
         this.inputValue = ""
          return
       }

      if (this.sendMsgTimer) {
        Toast("评论发送太快了");
        return;
      } else {
        this.sendMsgTimer = setTimeout(
          () => {
            clearTimeout(this.sendMsgTimer);
            this.sendMsgTimer = null;
          },
          type == 1 ? 5000 : 1000
        );
      }

      var that = this;
      var url = tool.baseUrl2() + "/comment/index/addSub";
      var url2 = tool.baseUrl2() + "/comment/index/add";

      var option = {
        fans_id: this.fans_id,
        ds_id: tool.getDs_id(),
        content: contentText,
        debug: 1,
        is_master: this.isMaster,
        quick_id: this.quick_id,
        fid: this.fid,
        comment_id: this.comment_id,
      };

      var option2 = {
        terminal_type: 1,
        fans_id: this.fans_id,
        ds_id: tool.getDs_id(),
        content: contentText,
        debug: 1,
        is_master: this.isMaster,
        quick_id: this.quick_id,
        fid: this.fid,
      };

      if (this.tid) {
        option.tid = this.tid;
        option2.tid = this.tid;
      }

      option = qs.stringify(option);
      option2 = qs.stringify(option2);

      this.commentBox = false;
      if (this.isReply) {
        this.isReply = false;
        this.placeholder = "请输入你要发表的内容";
        this.axios
          .post(url, option)
          .then(function(data) {
            var data = data.data;
            if (data.code == "200") {
              Toast("回复成功");
              that.commentBox = false;
              that.quick_id = "";
              that.fid = "";
            } else {
              Toast(data.message);
            }
          })
          .catch(function(data) {
            Toast("回复失败");
            that.quick_id = "";
            that.fid = "";
            console.log("错误" + data);
          });
      } else {

        if(that.say_self.enabled && that.say_self.all == 1){//全员自嗨
            that.sendMessageMySelf(contentText,'')
            if (type != 1) {
              that.inputValue = ""
            }
           return
        }

        this.axios
          .post(url2, option2,{timeout: 3000})
          .then(function(data) {
            var data = data.data;
            if (data.code == "200") {
              if (data.data.isCheck) {
                let newObj = Object.assign({}, data.data.content);
                newObj.module = "check_comment";
                handleIm.sendTextMsg(newObj);
              } else {
                handleIm.sendTextMsg(data.data.content);
              }
              Bus.$emit("messageisCheck", data.data.content);
              that.quick_id = "";
              that.fid = "";
              that.commentBox = false;
            } else {
               if (that.say_self.enabled) { //开启自嗨
                  that.sendMessageMySelf(contentText,'')
                }else{
                  Toast(data.message);
                }
              // Toast(data.message);
            }

            if (type != 1) {
              that.inputValue = ""
            }
          }).catch(function(error) {
            //判断是否有评论审核
            that.sendMessageBy505Error(contentText,'')
            if (type != 1) {
              that.inputValue = ""
            }
            that.quick_id = "";
            that.fid = "";
            console.log("错误" + data);
          });
      }
     
    },
    testSendMessage(text,pic_url){
      let app_id = localStorage.getItem("current_app_Id");
      if (app_id) {
          let userInfo = localStorage.getItem(app_id);
          if (userInfo) {
              let userInfo2 = JSON.parse(userInfo);
              let message  = {
                content: text,
                create_time: tool.getCommentTimes(),
                fans_id: userInfo2.fans_id,
                header: userInfo2.header,
                key: `${tool.getDs_id()}_comment_${(new Date).getTime()}`,
                like_num: 0,
                module: "text_comment",
                nick: userInfo2.nick,
                pic_url: pic_url,
                user_type: "real",
                terminal_type: 1,
                ds_id:tool.getDs_id(),
                _id: `${tool.getDs_id()}_comment_${(new Date).getTime()}`
              }
              Bus.$emit("messageisCheck", message);
          }
      } 
    },
    sendMessageMySelf(text,pic_url){
      let app_id = localStorage.getItem("current_app_Id");
      if (app_id) {
          let userInfo = localStorage.getItem(app_id);
          if (userInfo) {
              let userInfo2 = JSON.parse(userInfo);
              let message  = {
                content: text,
                create_time: tool.getCommentTimes(),
                fans_id: userInfo2.fans_id,
                header: userInfo2.header,
                key: `${tool.getDs_id()}_comment_${(new Date).getTime()}`,
                like_num: 0,
                module: "text_comment",
                nick: userInfo2.nick,
                pic_url: pic_url,
                user_type: "real",
                terminal_type: 1,
                ds_id:tool.getDs_id(),
                _id: `${tool.getDs_id()}_comment_${(new Date).getTime()}`
              }
              Bus.$emit("messageisCheck", message);
              if (this.say_self.type == 1) { //是否发送给助教
                handleIm.sendTextMsg(Object.assign({},message,{module:'my_self_hi'}));
              }
          }
      } 
    },
    sendMessageBy505Error(text,pic_url){
      let app_id = localStorage.getItem("current_app_Id");
      if (app_id) {
          let userInfo = localStorage.getItem(app_id);
          if (userInfo) {
              let userInfo2 = JSON.parse(userInfo);
              let message  = {
                content: text,
                create_time: tool.getCommentTimes(),
                fans_id: userInfo2.fans_id,
                header: userInfo2.header,
                key: `${tool.getDs_id()}_comment_${(new Date).getTime()}`,
                like_num: 0,
                module:"text_comment",
                nick: userInfo2.nick,
                pic_url: pic_url,
                user_type: "real",
                terminal_type: 1,
                ds_id:tool.getDs_id(),
                _id: `${tool.getDs_id()}_comment_${(new Date).getTime()}`
              }
              Bus.$emit("messageisCheck", message);
              if (this.verify_comment) { //审核评论
                 let message2 = Object.assign({},message)
                 message2.module = "check_comment"
                 handleIm.sendTextMsg(message2);
              }else{
                handleIm.sendTextMsg(message);
              }
          }
      } 
    },
    occupy() {
      if (!this.occupyImg) {
        if (this.occupyText) {
          console.log("111");
          this.occupySub();
        } else {
          Toast("霸屏内容为空！");
          return false;
        }
      } else {
        console.log("222");
        this.occupySub();
      }
    },
    occupySub() {
      var that = this;
      var url = tool.baseUrl2() + "/wall/pay_up_wall";
      var option =
        "fans_id=" +
        this.fans_id +
        "&content=" +
        this.occupyText +
        "&pay_level=" +
        (this.payLevel + 1) +
        "&wall_id=" +
        this.wall_id +
        "&pic_url=" +
        this.occupyImg;

      this.uploadAble = false;
      Toast.loading({
        mask: true,
        message: "发布中...",
      });
      this.axios
        .post(url, option)
        .then(function(data) {
          var data = data.data;
          that.uploadAble = true;
          if (data.code == 200) {
            that.occupyRefresh();
            that.weixinPay(data.data);
          } else {
            console.log(data.message);
          }
        })
        .catch(function(data) {
          that.uploadAble = true;
          //Toast(data);
        });
    },
    choice(index) {
      this.payLevel = index;
    },
    occupyShow() {
      this.occupyStatus = true;
    },
    occupyRefresh() {
      var that = this;
      this.occupyStatus = false;
      this.imgStatus = false;
      this.occupyImg = "";
      this.occupyText = "";
    },
    imgPl() {
      //设置未直播禁止发言
      if (
        this.directStatus == "end" &&
        this.userConfig && this.userConfig.all_no_speak
      ) {
        Toast("当前未直播禁止发言");
        return;
      }

      if (!this.occupyImg) {
        if (this.occupyText) {
          //500字符限制
          // if (this.occupyText.length > 500) {
          //   Toast("内容不能超过500字符");
          //   return;
          // }
          this.imgSub();
        } else {
          Toast("评论内容为空！");
          return false;
        }
      } else {
        this.imgSub();
      }
    },
    imgSub() {
       var that = this;
      
      if (that.say_self.enabled && that.say_self.all == 1) { //开启全员自嗨
          that.sendMessageMySelf(that.occupyText,that.occupyImg)
          that.occupyRefresh();
          return
      }
    
      var url = tool.baseUrl2() + "/comment/index/add";
      var option = {
        fans_id: this.fans_id,
        ds_id: tool.getDs_id(),
        content: this.occupyText,
        pic_url: this.occupyImg,
        debug: 1,
        terminal_type: 1,
      };
      console.log(option);
      this.uploadAble = false;
      Toast.loading({
        mask: true,
        message: "发布中...",
      });
      option = qs.stringify(option);
      // option = tool.encrypt(option);
      this.axios
        .post(url, option,{timeout: 3000}).then(function(data) {
          var data = data.data;
          that.uploadAble = true;
          if (data.code == "200") {
            if (data.data.isCheck) {
              let newObj = Object.assign({}, data.data.content);
              newObj.module = "check_comment";
              handleIm.sendTextMsg(newObj);
            } else {
              handleIm.sendTextMsg(data.data.content);
            }
            Bus.$emit("messageisCheck", data.data.content);
            that.occupyRefresh();
          } else {
            if (that.say_self.enabled) { //开启自嗨
              that.sendMessageMySelf(that.occupyText,that.occupyImg)
            }else{
              Toast(data.message);
            }
            that.occupyRefresh();
          }
        })
        .catch(function(data) {
          that.uploadAble = false;
          if (that.say_self.enabled) { //开启自嗨
            that.sendMessageMySelf(that.occupyText,that.occupyImg)
          }else{
            that.sendMessageBy505Error(that.occupyText,that.occupyImg)
          }
          that.occupyRefresh();
          // Toast("评论失败");
        });
    },
    weixinPay(p) {
      var that = this;
      var params =
        "appId:" +
        p.appId +
        "timeStamp:" +
        p.timeStamp +
        "nonceStr:" +
        p.nonceStr +
        "package:" +
        p.package +
        "sing:" +
        p.paySign;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: p.appId, //公众号名称，由商户传入
          timeStamp: String(p.timeStamp), //时间戳，自1970年以来的秒数
          nonceStr: p.nonceStr, //随机串
          package: p.package,
          signType: p.signType, //微信签名方式：
          paySign: p.paySign, //微信签名
        },
        function(res) {
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回		ok，但并不保证它绝对可靠。
          if (
            res.errMsg == "get_brand_wcpay_request:ok" ||
            res.err_msg == "get_brand_wcpay_request:ok"
          ) {
            Toast("霸屏成功！");
            console.log("霸屏成功！");
          } else {
            that.occupyStatus = false;
          }
        }
      );
    },
    sendTalk(msg, fid, type) {
      let Base64 = require("js-base64").Base64;
      var that = this;
      var url;
      if (type == 0) {
        url = tool.baseUrl() + "/comment/index/redPassword";
      } else {
        url = tool.baseUrl() + "/comment/index/couponPassword";
      }
      var option = {
        fans_id: this.fans_id,
        ds_id: tool.getDs_id(),
        content: msg,
        flag: 1,
      };

      option = tool.encrypt(option);
      this.fid = fid;

      this.axios
        .post(url, option)
        .then(function(res) {
          var data = res.data;
          if (data.code == 200) {
            setTimeout(function() {
              that.$emit("showtalk", data.data);
            }, 1000);
            that.inputValue = msg;
            that.sendMsg();
          } else {
            Toast(data.message);
            that.$emit("colsetalkred");
          }
        })
        .catch(function(res) {
          console.log(res);
        });
    },
    sendquickMsgAction(index) {
      this.isShowQuickPanel = false;
      this.inputValue = this.commentList[index].comment;
      this.quick_id = this.commentList[index].id;
      this.sendMsg();
    },
    gift(item) {
      var self = this;
      clearTimeout(this.giftTimer);
      this.giftMessages = item;
      this.showgift = false;
      this.showgetGift = true;
      this.giftTimer = setTimeout(function() {
        self.showgetGift = false;
      }, 3000);
    },
    reply(item) {
      //回复
      this.isReply = true;
      this.comment_id = item._id;
      this.inputValue = "";
      this.placeholder = "请输入回复" + item.nick + "的内容";
      if (this.isIOS) {
        Bus.$emit("showcomment");
      } else {
        Bus.$emit("focus");
      }
    },
  },
};
</script>

<style scoped>
.van-popup {
  border-radius: 2px;
  margin-top: 80px;
}

.roomBar {
  position: fixed;
  display: -webkit-box;
  display: -moz-box;
  display: flex;
  bottom: 0;
  background-color: #eeeeee;
  width: 100%;
  /* height: 40px; */
  padding: 5px 0;
  align-items: center;
  z-index: 1401;
  box-shadow: 0px -3px 10px #ddd;
}

.roomBar.typebg2 {
  background: #333333;
}

.roomBar.typebg3 {
  background: #ec1a1a;
}
.bottom-zan,
.bottom-gift {
  margin-left: 5px;
  height: 30px;
  width: 30px;
  padding: 3px;
}

.bottom-img {
  width: 100%;
}

.quick-button {
  border-radius: 5px;
  border: none;
  margin-left: 10px;
  width: 90px;
  font-size: 13px;
  padding: 0 5px;
  height: 30px;
  color: #fff;
}

.inputValue {
  display: block;
  height: 30px;
  border: none;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 12px;
  border-radius: 5px;
  padding-left: 10px;
  padding-right: 8px;
  flex: 1;
  background: #fff;
  line-height: 30px;
}

.bottom-button {
  height: 30px;
  width: 50px;
  padding: 0;
  line-height: 30px;
  margin-right: 10px;
  border: none;
  border-radius: 5px;
  padding-bottom: 0;
  color: #fff;
}

.type1 {
  background-color: #1483ff;
  border-color: #1483ff;
}

.type2 {
  background-color: #e5bc4b;
  border-color: #e5bc4b;
}

.type3 {
  background-color: #e5bc4b;
  border-color: #e5bc4b;
}

.textarea {
  border: none;
  width: 100%;
  resize: none;
  box-sizing: border-box;
  padding: 5px;
}

.btnBox {
  display: -webkit-box;
  display: -moz-box;
  display: flex;
  text-align: center;
}

.btnBox .btn {
  flex: 1;
  height: 42px;
  line-height: 42px;
  color: #fff;
  font-size: 16px;
}

.btnBox .btn:first-child {
  background: #0084ff;
}

.quickArrow {
  width: 30px;
  height: 30px;
  transform: rotate(45deg) translateX(-50%);
  background-color: white;
  position: absolute;
  left: 50%;
  bottom: 46px;
}

.quickPanel {
  position: absolute;
  background-color: white;
  max-height: 410px;
  min-height: 100px;
  padding: 10px 0;
  border-radius: 5px;
  overflow: scroll;
  bottom: 60px;
  width: 100%;
}

.quickPanel li {
  padding: 8px 20px;
  display: -webkit-box;
  display: -moz-box;
  display: flex;
}

.getGift {
  text-align: center;
  position: fixed;
  font-size: 18px;
  line-height: 18px;
  top: 50%;
  padding: 10px;
  width: 80%;
  left: 50%;
  z-index: 1900;
  margin-left: -40%;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 0 6px 1px #b1b1b1;
}

.giftImg {
  position: absolute;
  top: -100px;
  width: 80px;
  height: 80px;
  left: 50%;
  margin-left: -40px;
  animation: changebig 1.5s infinite;
}

@keyframes changebig {
  0% {
    width: 80px;
  }
  30% {
    transform: scale(1.2, 1.2);
  }
  100% {
    transform: scale(1, 1);
  }
}

.getGift .name {
  color: rgb(255, 64, 64);
}

.getGift .num {
  color: rgb(255, 163, 64);
  font-style: italic;
  font-weight: bold;
}

.occupy {
  color: #262626;
  line-height: 28px;
}

.occupy .title {
  position: absolute;
  top: -50px;
  font-size: 28px;
  color: #e5bc4b;
}

.occupy .textarea {
  position: relative;
}

.occupy textarea {
  width: 100%;
  border: 1px solid #cccccc;
  border-radius: 5px;
  resize: none;
  box-sizing: border-box;
}

.occupy textarea::placeholder {
  color: #cccccc;
}

.occupy .number {
  position: absolute;
  right: 7px;
  background: #fff;
  bottom: 16px;
  line-height: 20px;
}

.occupy .number span {
  color: #e5bc4b;
}

.occupy .addimg {
  position: relative;
  min-height: 100px;
  overflow: hidden;
}

.occupy .addimg .img {
  width: 100px;
  height: 100px;
  overflow: hidden;
  position: relative;
}

.occupy .addimg .img img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.occupy .addimg .guide {
  width: 50px;
}

.occupy .addimg .container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  height: 100px;
}

.occupy .addimg .buttom {
  background: #579fee;
  color: #fff;
  padding: 0 4px;
  border-radius: 5px;
  display: inline-block;
  vertical-align: top;
}

.occupy .addimg .success {
  background: #83bb01;
}

.occupy .times a {
  display: inline-block;
  text-align: center;
  width: 30%;
  margin-right: 1%;
  height: 34px;
  line-height: 34px;
  border: 1px solid #cccccc;
  border-radius: 5px;
}

.occupy .times .cur {
  background: #e5bc4b;
  border-color: #e5bc4b;
  color: #fff;
}

.occupy .money {
  margin: 10px 0;
}

.occupy .money span {
  color: #e5bc4b;
  font-weight: bold;
  font-size: 20px;
}

.occupy .btns {
  margin-bottom: 10px;
}

.occupy .btns a {
  width: 40%;
  margin: 0 4%;
  display: inline-block;
  line-height: 34px;
  height: 34px;
  border: 1px solid #e5bc4b;
  border-radius: 17px;
  text-align: center;
  color: #e5bc4b;
}

.occupy .btns a:last-child {
  background: #e5bc4b;
  color: #fff;
}

.occupy .prompt {
  color: #e5bc4b;
}

.selectfiles {
  width: 100px;
  height: 100px;
}

.imgPl .addimg {
  margin: 5px;
  border: 1px dashed #8e8e8e;
  text-align: center;
  width: 100px;
  height: 100px;
  line-height: 100px;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.imgPl .addimg img {
  position: absolute;
  left: 50%;
  top: 50%;
  max-width: 90%;
  max-height: 90%;
  transform: translate(-50%, -50%);
}

.imgPl .addimg:before,
.imgPl .addimg:after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  background: #979797;
  z-index: -1;
}

.imgPl .addimg:before {
  height: 24px;
  width: 2px;
  margin-left: -1px;
  margin-top: -12px;
}

.imgPl .addimg:after {
  width: 24px;
  height: 2px;
  margin-left: -12px;
  margin-top: -1px;
}

.imgPl .addimg p {
  margin-top: 30px;
  font-size: 16px;
}

.imgPl .textarea {
  margin: 20px 5px;
  border-top: 1px solid #c0c0c0;
  padding-top: 5px;
}

.imgPl textarea {
  border: none;
}

.imgPl .btns {
  display: -webkit-box;
  display: -moz-box;
  display: flex;
}

.imgPl .btns a {
  flex: 1;
  margin: 0 5px;
  border-radius: 6px;
  height: 42px;
  line-height: 42px;
  font-size: 16px;
}

.imgPl .btns a.disabled,
.occupy .btns a.disabled {
  background: #ccc;
  border-color: #ccc;
}

.bottomView {
  border-radius: 0px !important;
}
.senMsgBtn{
  margin-right: 10px;
  background: linear-gradient(137deg,#73aaff 5%, #0053ff 93%);
  border-radius: 4px;
  border: none;
}
</style>



// WEBPACK FOOTER //
// toolbar.vue?f464ab2a